import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_BASH_URL;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('shinpay-vendor-token')}`,
  'Content-Type': 'application/json',
});

export const fetchEmployeeModulesConfig = createAsyncThunk(
  'employeeModules/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${BaseUrl}/vendor/employee-modules`, {
        headers: getHeaders(),
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchEmployeeAccess = createAsyncThunk(
  'employeeModules/fetchAccess',
  async (employeeId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${BaseUrl}/vendor/employee/${employeeId}/access`,
        { headers: getHeaders() }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const updateEmployeeAccess = createAsyncThunk(
  'employeeModules/updateAccess',
  async ({ employeeId, permissions }, { rejectWithValue }) => {
    try {
      await axios.post(
        `${BaseUrl}/vendor/employee/${employeeId}/access`,
        { permissions },
        { headers: getHeaders() }
      );
      return { employeeId, permissions };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const employeeModuleSlice = createSlice({
  name: 'employeeModules',
  initialState: {
    modulesConfig: [],
    employeeAccess: { activeModules: [] },
    loading: false,
    error: null,
  },
  reducers: {
    clearEmployeeModuleError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeModulesConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeModulesConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.modulesConfig = action.payload;
      })
      .addCase(fetchEmployeeModulesConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchEmployeeAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeAccess = action.payload;
      })
      .addCase(fetchEmployeeAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateEmployeeAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEmployeeAccess.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateEmployeeAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearEmployeeModuleError } = employeeModuleSlice.actions;
export default employeeModuleSlice.reducer;
